module.exports = __webpack_public_path__ + "img/session-organic-form-blue.032cb441.png";